import { render, staticRenderFns } from "./OrderUpdateConfirmationPage.vue?vue&type=template&id=1cdd08ad"
import script from "./OrderUpdateConfirmationPage.vue?vue&type=script&lang=js"
export * from "./OrderUpdateConfirmationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports